import SwitchClass from 'www/modules/ClassSwitcher/ClassSwitcher'
import { switchClassEllipsis, scrollTo } from 'www/utils'

const optionSwitchClassEllipsis = {
  containerSelector: '.b-expanded',
  textSelector: '.b-expanded__body',
  notLimitedClass: 'b-expanded_not-limited',
  limitHeight: 160,
}

switchClassEllipsis(optionSwitchClassEllipsis)

window.addEventListener('orientationchange', () => {
  setTimeout(() => switchClassEllipsis(optionSwitchClassEllipsis))
})

new SwitchClass({
  parent: '.b-expanded',
  button: '.b-expanded__button',
  parentActiveClass: 'b-expanded_expanded',
  buttonText: {
    added: 'Скрыть',
    removed: 'Показать все',
  },
  afterRemove: options => {
    scrollTo(options.parent.offsetTop, {
      offset: -70,
    })
  },
})
